<template>
  <div class="computer">
    <div class="title">
      间接费用计算小助手
      <van-icon name="question-o" @click="showHint2" style="margin:0px 10px;" />
    </div>
    <div class="form-input">
      <van-form @submit="onSubmit">
        <van-field
          class="input-field"
          v-model="totalMoney"
          type="number"
          label="总经费"
          :clearable="true"
          placeholder="请输入(万元)"
          :rules="[{ required: true, message: ' ' }]"
        />
        <van-field
          v-model="purchaseCost"
          type="number"
          :label="deviceCostLabel"
          class="input-field"
          :clearable="true"
          placeholder="请输入,默认为0(万元)"
        />
        <van-field name="radio" label="项目类型" class="input-field">
          <template #input>
            <van-radio-group v-model="radio" style="font-size: 14px">
              <div
                style="display: flex; align-items: center; margin-top: 10px;"
              >
                <van-radio name="national_research_project">国家重点研发等科技研究类项目</van-radio>
                <van-icon
                  name="question-o"
                  @click="showSinceHint"
                  style="margin-left: 20px;"
                />
              </div>
              <div
                style="display: flex; align-items: center; margin-top: 10px;"
              >
                <van-radio name="provincial_research_project"
                  >省级科技研究类项目</van-radio
                ><van-icon
                  name="question-o"
                  @click="showHint"
                  style="margin-left: 20px;"
                />
              </div>
              <div
                style="display: flex; align-items: center; margin-top: 10px;"
              >
                <van-radio name="other_project"
                  >其他类项目</van-radio
                ><van-icon
                  name="question-o"
                  @click="showHintOther"
                  style="margin-left: 20px;"
                />
              </div>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          class="input-field"
          v-model="directMoney"
          type="number"
          :clearable="true"
          label="直接费用"
        />
        <van-field
          class="input-field"
          v-model="indirectMoney"
          type="number"
          label="间接费用"
          :clearable="true"
        />
        <div style="margin: 16px;">
          <van-button
            style=" font-size: 16px"
            round
            block
            type="warning"
            @click.stop.prevent="reset"
          >
            重置
          </van-button>
          <van-button
            round
            block
            type="info"
            native-type="submit"
            style="margin-top: 20px;font-size: 16px"
          >
            计算费用
          </van-button>
        </div>
      </van-form>
    </div>
    <!-- <div style="text-align: left; ">
      <div>间接费用按直接费用扣除设备购置费后的比例计算：</div>
      <div style="display: flex;">
        <span>1.</span> 500万元及以下的部分为20%；
      </div>
      <div style="display: flex;">
        <span>2.</span> 500万元至1000万元的部分为15%；
      </div>
      <div style="display: flex;">
        <span>3.</span> 1000万元以上的部分为13％.
      </div>
    </div> -->
    <!-- <div style="text-align: left;">
      <div>
        试验设备依赖程度低和实验材料耗费少的基础研究、软件开发、集成电路设计、科研咨询、科技服务、软科学研究、智库等智力密集型项目。
      </div>
      <div style="margin-top: 6px">
        间接费用按直接费用扣除设备购置费后的比例计算：
      </div>
      <div style="display: flex;align-items: center;margin-top: 6px">
        <span>1.</span> 500万元以下的部分为30%；
      </div>
      <div style="display: flex;align-items: center;margin-top: 6px">
        <span>2.</span> 500万元至1000万元的部分为25%；
      </div>
      <div style="display: flex;align-items: center;margin-top: 6px">
        <span>3.</span> 1000万元以上的部分为20%.
      </div>
    </div> -->
    <div class="foot-text">
      <span v-if="count">
        第 {{count}} 次计算服务
      </span>
      &copy;中山大学数智融合实验室
    </div>
  </div>
</template>
<script>
import { computeMoney, computeCount} from "../../api/computer.js";
export default {
  name: "computer",
  data() {
    return {
      totalMoney: "",
      tempTotalMoney: "", //暂存总经费
      radio: "national_research_project",
      purchaseCost: "",
      directMoney: "",
      tempDirectMoney: "",
      indirectMoney: "",
      tempIndirectMoney: "",
      hint:
        `
        <div style="text-align: justify; "><div>省级科技研究类项目</div><div style="display: flex;margin-top: 2px;white-space: nowrap">间接费用按直接费用扣除设备费后的30%计算.</div>
        `,
        // '<div style="text-align: justify;"><div>试验设备依赖程度低和实验材料耗费少的基础研究、软件开发、集成电路设计、科研咨询、科技服务、软科学研究、智库等智力密集型项目。</div><div style="margin-top: 20px">智力密集型项目</div><div>间接费用按直接费用扣除设备购置费后的比例计算：</div><div style="display: flex;margin-top: 2px; white-space: nowrap"><span>1.</span> 500万元及以下的部分为30%;</div><div style="display: flex;margin-top: 2px; white-space: nowrap"><span>2.</span> 500万元至1000万元的部分为25%;</div><div style="display: flex;margin-top: 2px; white-space: nowrap"><span>3.</span> 1000万元以上的部分为20%.</div></div>',
      hint2:
        "<div style='text-align: justify'>根据您输入的总经费和设备购置费，计算出直接费用和间接费用，使得间接费用最大。</div>",
      hint3:
        '<div style="text-align: justify; "><div>国家重点研发等科技研究类项目</div><div>间接费用按直接费用扣除设备购置费后的比例计算：</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>1.</span> 500万元及以下的部分为30%;</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>2.</span> 500万元至1000万元的部分为25%;	</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>3.</span> 1000万元以上的部分为20%.</div></div>',
      writeFlag1: false,
      hintOther: '<div style="text-align: left; "><div>其他类项目</div><div>间接费用按直接费用扣除设备购置费后的比例计算：</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>1.</span> 500万元及以下的部分为20%;</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>2.</span> 500万元至1000万元的部分为15%;	</div><div style="display: flex;margin-top: 2px;white-space: nowrap"><span>3.</span> 1000万元以上的部分为13％.</div></div>',

      writeFlag2: false,
      count: '0' // 计算次数
    };
  },	
  computed: {
    deviceCostLabel () {
      return this.radio === 'provincial_research_project' ? '设备费' : '设备购置费'
    }
  },
  watch: {
    totalMoney(val, val2) {
      this.tempTotalMoney = "";
      this.totalMoney = val.replace(/^(0{2,}|\.)/g, "0");
    },
    purchaseCost(val) {
      this.tempTotalMoney = "";
      this.purchaseCost = val.replace(/^(0{2,}|\.)/g, "0");
    },
    directMoney(val, oldVal) {
      if (this.writeFlag2) {
        this.writeFlag2 = false;
        return;
      }
      console.log("directMoney", val);
      if (this.tempTotalMoney == "") {
        this.$toast("请您先用程序自动计算，再进行调整");
        this.directMoney = "";
        return;
      }
      if (val < 0) {
        this.indirectMoney = oldVal;
        return;
      }
      console.log(val);
      let newVal = (val + "").replace(/^(0{2,}|\.)/g, "0") - 0;
      console.log(newVal);
      if (isNaN(newVal)) {
        newVal = 0;
        setTimeout(() => {
          this.directMoney = 0;
        }, 100);
        return;
      }
      if (newVal > this.tempTotalMoney - 0) {
        this.$toast("直接费用不能大于总经费: " + this.tempTotalMoney);
        this.directMoney = val;
      } else if (newVal < this.tempDirectMoney - 0) {
        this.$toast("直接费用不能低于最小值: " + this.tempDirectMoney);
      } else {
        this.writeFlag1 = true;
        let temp = (newVal + "").split(".")[1];
        let fixed = 2;
        if (!temp) {
          fixed = 2;
        } else {
          fixed = temp.length <= 2 ? 2 : temp.length;
        }
        console.log(fixed, temp);
        this.indirectMoney = (this.tempTotalMoney - newVal).toFixed(fixed);
      }
    },
    indirectMoney(val, oldVal) {
      if (this.writeFlag1) {
        this.writeFlag1 = false;
        return;
      }
      console.log("indirecmoney", val);
      if (this.tempTotalMoney == "") {
        this.$toast("请您先用程序自动计算，再进行调整");
        this.indirectMoney = "";
        return;
      }
      if (val < 0) {
        this.indirectMoney = 0;
        return;
      }

      let newVal = (val + "").replace(/^(0{2,}|\.)/g, "0") - 0;
      console.log("newVal", newVal, val);
      if (isNaN(newVal)) {
        newVal = 0;
      }
      if (newVal > this.tempIndirectMoney - 0) {
        this.$toast("间接费用不能大于最大值: " + this.tempIndirectMoney);
        this.indirectMoney = val;
        return;
      } else {
        this.writeFlag2 = true;
        let temp = (newVal + "").split(".")[1];
        let fixed = 2;
        if (!temp) {
          fixed = 2;
        } else {
          fixed = temp.length <= 2 ? 2 : temp.length;
        }
        this.directMoney = (this.tempTotalMoney - newVal).toFixed(fixed);
      }
    },
  },
  created() {
    let indirect_funding = "66.6666666666667";
    console.log(
      indirect_funding.substr(indirect_funding.indexOf(".") + 1, 2) - 0
    );
    console.log(indirect_funding.substr(0, indirect_funding.indexOf(".")) - 0);
    let res =
      indirect_funding.substr(0, indirect_funding.indexOf(".")) -
      0 +
      "." +
      (indirect_funding.substr(indirect_funding.indexOf(".") + 1, 2) - 0) -
      0;
    console.log(res);
    this.init()
  },
  methods: {
    init() {
      computeCount().then(res => {
        const data = res.data
        if (data.result === 'success') {
          this.count = data.msg
        }
      })
    },
    onSubmit(values) {
      console.log(this.totalMoney, parseInt(this.purchaseCost));
      if (this.totalMoney - 0 < this.purchaseCost - 0) {
        this.$toast(`总经费不能小于${this.deviceCostLabel}`);
        return;
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "计算中...",
      });
      this.tempTotalMoney = this.totalMoney;
      let data = {
        A: this.totalMoney,
        B: this.purchaseCost ? this.purchaseCost : 0,
        project_type: this.radio,
      };
      computeMoney(data).then((res) => {
        console.log(res);
        const { result, msg } = res.data;
        toast.clear();
        if (result == "success") {
          this.writeFlag1 = true;
          this.writeFlag2 = true;
          let { direct_funding, indirect_funding } = msg;
          this.indirectMoney = indirect_funding;
          this.directMoney = direct_funding;
          this.tempDirectMoney = this.directMoney;
          this.tempIndirectMoney = this.indirectMoney;
          this.init()
        }
      });
    },
    // 浮点型数字保留两位两位小数， 整型直接返回
    formatNum(val) {
      console.log(val);
      if (val.indexOf(".") == -1) {
        return val;
      } else {
        let res =
          val.substr(0, val.indexOf(".")) +
          "." +
          val.substr(val.indexOf(".") + 1, 2) -
          0;
        console.log(res);
        return res;
      }
    },
    reset() {
      this.$dialog
        .confirm({
          title: "警告",
          message: "确认清空输入框里的所有数据吗？",
        })
        .then(() => {
          this.totalMoney = "";
          this.purchaseCost = "";
          this.directMoney = "";
          this.indirectMoney = "";
          this.radio = "national_research_project";
        })
        .catch(() => {
          // on cancel
        });
    },
    showHint() {
      this.$dialog.alert({
        message: this.hint,
      });
    },
    showHint2() {
      this.$dialog.alert({
        message: this.hint2,
      });
    },
    showSinceHint() {
      this.$dialog.alert({
        message: this.hint3,
      });
    },
    showHintOther () {
      this.$dialog.alert({
        message: this.hintOther
      })
    }
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
